// extracted by mini-css-extract-plugin
module.exports = {"app":"index_app_123vq"};